<template>
  <div class="login-page">
    <svg
      class="svgbg light-wave"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1000 500"
    >
      <path
        fill-rule="evenodd"
        fill="rgb(102, 125, 232)"
        d="M1.000,23.000 C54.176,37.648 62.875,0.531 147.000,100.000 C231.125,199.469 414.297,187.773 482.000,188.000 C549.703,188.227 878.184,188.418 1000.000,415.000 C1000.000,29.970 1000.000,23.000 1000.000,23.000 L-0.000,23.000 L1.000,23.000 Z"
      />
    </svg>
    <svg
      class="svgbg dark-wave"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1000 500"
    >
      <path
        fill-rule="evenodd"
        fill="rgb(37, 47, 92)"
        d="M1.000,23.000 C54.176,37.648 62.875,0.531 147.000,100.000 C231.125,199.469 414.297,187.773 482.000,188.000 C549.703,188.227 878.184,188.418 1000.000,415.000 C1000.000,29.970 1000.000,23.000 1000.000,23.000 L-0.000,23.000 L1.000,23.000 Z"
      />
    </svg>
    <!-- <app-navbar></app-navbar> -->
    <div class="wrapper wrapper-full-page">
      <div class="login-page" v-bind:class="{ loading: loading }">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <!-- <form @submit="submit"> -->
              <card type="login">
                <h3 slot="header" class="header text-center" v-translate>
                  Log in
                </h3>
                <small
                  class="text-danger"
                  v-for="error in errorsMessages.nonFieldErrors"
                  >{{ error }}</small
                >
                <div class="loader_holder">
                  <object
                    type="image/svg+xml"
                    data="/assets/loaders/infinity.svg"
                    class="loading"
                  ></object>
                </div>
                <fg-input
                  v-model="form.email"
                  addon-left-icon="nc-icon nc-single-02"
                  :placeholder="'Email' | translate"
                  v-on:keyup.enter="loginOnEnter"
                  ref="email_input"
                ></fg-input>
                <fg-input
                  v-model="form.password"
                  addon-left-icon="nc-icon nc-key-25"
                  :placeholder="'Password' | translate"
                  type="password"
                  v-on:keyup.enter="loginOnEnter"
                  ref="password_input"
                ></fg-input>
                <p-button
                  slot="footer"
                  type="success"
                  round
                  block
                  class="mb-3"
                  :disabled="!(form.email && form.password)"
                  native-type="submit"
                  @click="login"
                >
                  <translate>Login</translate>
                </p-button>
              </card>
              <div class="additional_links">
                <router-link to="/signup">Впервые у нас?</router-link>
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";

import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
var apiDriver = require("../Actid/apiDriver").default;

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },
  methods: {
    loginOnEnter() {
      let email_el = this.$refs.email_input.$el.querySelector("input");
      let password_el = this.$refs.password_input.$el.querySelector("input");
      if (this.form.email == "") {
        console.log("email", email_el);
        email_el.focus();
        return;
      }
      if (this.form.password == "") {
        console.log("password", password_el);
        password_el.focus();
        return;
      }
      email_el.blur();
      password_el.blur();
      this.login();
    },
    async login() {
      this.loading = true;
      this.$auth.login({
        data: {
          email: this.form.email,
          password: this.form.password,
        },
        success: async () => {
          var account = await apiDriver.account();
          setTimeout(function () {
            var url = new URL(document.location.href);
            var redirect = url.searchParams.get("redirect");
            if (redirect) {
              document.location.href = redirect;
            } else {
              document.location.href = "/";
            }
          }, 1000);
        },
        error: (response) => {
          swal({
            title: `Ошибка входа`,
            text: "Пожалуйста, попробуйте другой Email или пароль.",
            type: "error",
          });
          this.loading = false;
        },
        rememberMe: true,
        redirect: false,
        fetchUser: false,
      });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
  },
  data() {
    return {
      loading: false,
      errorsMessages: {
        nonFieldErrors: [],
      },
      form: {
        email: "",
        password: "",
      },
    };
  },
  beforeDestroy() {
    this.closeMenu();
  },
  mounted() {
    // console.log("kekekeke")
    if (window.user_email) {
      this.form.email = window.user_email;
      this.form.password = window.user_password;
    }
  },
};
</script>
<style>
.additional_links {
  text-align: center;
}
.additional_links a {
  color: rgb(185, 185, 185);
}
.additional_links a:hover {
  color: #657de8;
}

.login-page .content .container {
  margin-top: 18vh;
}

.input-group-text {
  padding-right: 10px !important;
}

.svgbg {
  width: 100%;
  position: absolute;
  z-index: 0;
  top: -50px;
  left: 0;
}

.full-page .full-page-background {
}

.card-header h3 {
  color: #3b51b5;
}

.forgot a {
  color: #667de8 !important;
}

.form-group input {
  padding: 20px !important;
}

.login-page .loader_holder {
  text-align: center;
  display: none;
}

.login-page.loading .loader_holder {
  display: block;
}

.login-page.loading .form-group,
.login-page.loading .forgot,
.login-page.loading .card-footer {
  display: none;
}

.login-page .card-login .input-group:last-child {
  margin-bottom: 0px !important;
}

.dark-wave {
  display: none;
}

@media (prefers-color-scheme: dark) {
  .light-wave {
    display: none;
  }
  .dark-wave {
    display: block;
  }
}
</style>
